import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import { nextTopIndex, nextChildIndex } from '@/utils/pageIndex.js'
import { stripDuplicateAppletPages } from '@/utils/platformPages.js'
const pages = {
  pageTabs: [
    {
      label: 'web端页面',
      theme: 'pages',
      step: 'webPageList',
      stepLabel: 'web端页面列表',
      checkFun: 'pages/getAllWebPages'
    },
    {
      label: '小程序页面',
      theme: 'pages',
      step: 'appletPageList',
      stepLabel: '小程序页面列表',
      checkFun: 'pages/getAllAppletPages'
    }
  ],
  webPage: {
    name: 'webPage',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'pages/getAllWebPages',
    addFun: 'pages/addWebPage',
    editFun: 'pages/editWebPage',
    detailPage: [
      {
        buttonName: '新增顶级页面',
        type: 'stepForm',
        name: 'webPage',
        theme: 'pages',
        step: 'webPageInfo',
        label: '新增web端页面',
        checkType: 'detailData',
        detailData: {
          upLevel: '1',
          index: (params) => {
            return nextTopIndex(params.state.pages.allWebPages, 'index')
          },
          pageName: '',
          path: '',
          name: '',
          redirect: '',
          component: '',
          meta: '',
          pageIco: '',
          reportUid: '',
          reportType: 'defaultreport',
          reportGroup: '',
          reportGroupName: ''
        }
      },
      {
        buttonName: '新增下级',
        type: 'stepForm',
        name: 'webPage',
        theme: 'pages',
        step: 'webPageInfo',
        label: '新增web端页面'
      },
      {
        buttonName: '编辑',
        type: 'stepForm',
        name: 'webPage',
        theme: 'pages',
        step: 'webPageInfo',
        checkType: 'useRowData',
        label: '编辑web端页面'
      }
    ],
    headButtons: setCheckButtons(['新增顶级页面']),
    rowKey: 'pageUid',
    outListHeight: 240,
    tableHeightShrink: 20,
    rowData: (params) => {
      return params.state.pages.allWebPages
    },
    columns: [
      { prop: 'pageName', label: '\xa0\xa0页面名称', align: 'left' },
      { prop: 'index', label: '页面序号' },
      { prop: 'pageCode', label: '页面code', width: '240px' },
      { prop: 'path', label: '页面路由', width: '360px' },
      { prop: 'icon', label: '页面图标', width: '240px' },
      { prop: 'component', label: '页面组件', width: '' },
      {
        label: '操作',
        width: '400px',
        buttons: setTableButtons(['新增下级', '编辑', '上移', '下移'])
      }
    ],
    formParams: {
      upLevel: (params) => {
        return params.currentRow && params.currentRow.pageUid
      },
      index: (params) => {
        return nextChildIndex(
          params.currentRow && params.currentRow.index,
          params.currentRow && params.currentRow.children,
          'index'
        )
      },
      pageName: '',
      path: '',
      name: '',
      redirect: '',
      component: '',
      meta: '',
      pageIco: '',
      reportUid: '',
      reportType: 'defaultreport',
      reportGroup: '',
      reportGroupName: ''
    },
    formRules: {
      index: [
        {
          required: true,
          message: '请输入页面序号',
          trigger: 'blur'
        },
        {
          pattern: /^[0-9-]{1,}$/,
          message: '请输入英文字符、数字或下划线组成的唯一标识',
          trigger: 'blur'
        }
      ],
      pageName: [
        {
          required: true,
          message: '请输入页面名称',
          trigger: 'blur'
        }
      ],
      path: [
        {
          required: true,
          message: '请输入页面路由',
          trigger: 'input'
        },
        {
          pattern: /^\/[\d\D]{1,}$/,
          message: '输入的路由不合法',
          trigger: 'blur'
        }
      ],
      name: [
        {
          required: true,
          message: '请输入路由名称',
          trigger: 'blur'
        },
        {
          pattern: /^[0-9a-zA-Z_]{1,}$/,
          message: '请输入英文字符、数字或下划线组成的唯一标识角色',
          trigger: 'blur'
        }
      ],
      component: [
        {
          pattern: /^[0-9a-zA-Z_]{1,}$/,
          message: '请输入英文字符、数字或下划线组成的唯一标识角色',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '页面配置信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'upLevel',
          label: '上级页面',
          type: 'cascader',
          options: (params) => {
            return params.state.pages.allWebPages
          },
          placeholder: '不选择上一级页面会默认新增为最顶级页面',
          clearable: true,
          checkByValue: true,
          checkStrictly: true,
          emitPath: false
        },
        {
          key: 'index',
          label: '页面序号',
          type: 'input'
        },
        {
          key: 'pageName',
          label: '页面名称',
          type: 'input'
        },
        {
          key: 'path',
          label: '页面路由',
          type: 'input'
        },
        {
          key: 'name',
          label: '路由名称',
          type: 'input'
        },
        {
          key: 'redirect',
          label: '重定向路由',
          type: 'input'
        },
        {
          key: 'component',
          label: '页面组件',
          type: 'input'
        },
        {
          key: 'pageIco',
          label: '页面图标',
          type: 'input'
        },
        {
          key: 'reportUid',
          label: '报表模版uid',
          type: 'input',
          placeholder: '报表类页面填写模版uid，普通页面留空'
        },
        {
          key: 'reportType',
          label: '报表加载类型',
          type: 'input',
          placeholder: '默认 defaultreport'
        },
        {
          key: 'reportGroup',
          label: '报表分组编码',
          type: 'input',
          placeholder: '如 managerReport、findReport'
        },
        {
          key: 'reportGroupName',
          label: '报表分组名称',
          type: 'input',
          placeholder: '如 管理报表、查询报表'
        }
      ]
    }
  },
  appletPage: {
    name: 'appletPage',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    detailPage: [
      {
        buttonName: '新增顶级页面',
        type: 'stepForm',
        name: 'appletPage',
        theme: 'pages',
        step: 'appletPageInfo',
        label: '新增小程序页面',
        checkType: 'detailData',
        detailData: {
          parentUid: '1',
          pageIndex: (params) => {
            return nextTopIndex(params.state.pages.allAppletPages, 'pageIndex')
          },
          pageName: '',
          pagePath: '',
          pageIcon: ''
        }
      },
      {
        buttonName: '新增下级',
        type: 'stepForm',
        name: 'appletPage',
        theme: 'pages',
        step: 'appletPageInfo',
        label: '新增小程序页面'
      },
      {
        buttonName: '编辑',
        type: 'stepForm',
        name: 'appletPage',
        theme: 'pages',
        step: 'appletPageInfo',
        checkType: 'useRowData',
        label: '编辑小程序页面'
      }
    ],
    headButtons: setCheckButtons(['新增顶级页面']),
    addFun: 'pages/addAppletPage',
    editFun: 'pages/editAppletPage',
    getListFun: 'pages/getAllAppletPages',
    outListHeight: 240,
    tableHeightShrink: 20,
    rowKey: 'pageUid',
    rowData: (params) => {
      return stripDuplicateAppletPages(params.state.pages.allAppletPages)
    },
    columns: [
      { prop: 'pageName', label: '\xa0\xa0页面名称', align: 'left' },
      { prop: 'pageIndex', label: '页面序号' },
      { prop: 'pagePath', label: '页面路由', width: '360px' },
      { prop: 'pageIcon', label: '页面图标', width: '240px' },
      {
        label: '操作',
        width: '400px',
        buttons: setTableButtons(['新增下级', '编辑', '上移', '下移'])
      }
    ],
    formParams: {
      parentUid: (params) => {
        return params.currentRow && params.currentRow.uid
      },
      pageIndex: (params) => {
        return nextChildIndex(
          params.currentRow && params.currentRow.pageIndex,
          params.currentRow && params.currentRow.children,
          'pageIndex'
        )
      },
      pageName: '',
      pagePath: '',
      pageIcon: ''
    },
    formRules: {
      pageIndex: [
        {
          required: true,
          message: '请输入页面序号',
          trigger: 'blur'
        },
        {
          pattern: /^[0-9-]{1,}$/,
          message: '请输入英文字符、数字或下划线组成的唯一标识',
          trigger: 'blur'
        }
      ],
      pageName: [
        {
          required: true,
          message: '请输入页面名称',
          trigger: 'blur'
        }
      ],
      pagePath: [
        {
          required: true,
          message: '请输入页面路由',
          trigger: 'input'
        },
        {
          pattern: /^\/[\d\D]{1,}$/,
          message: '输入的路由不合法',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '页面配置信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'parentUid',
          label: '上级页面',
          type: 'cascader',
          options: (params) => {
            return stripDuplicateAppletPages(params.state.pages.allAppletPages)
          },
          placeholder: '不选择上一级页面会默认新增为最顶级页面',
          clearable: true,
          checkByValue: true,
          checkStrictly: true,
          emitPath: false
        },
        {
          key: 'pageIndex',
          label: '页面序号',
          type: 'input'
        },
        {
          key: 'pageName',
          label: '页面名称',
          type: 'input'
        },
        {
          key: 'pagePath',
          label: '页面路由',
          type: 'input'
        },
        {
          key: 'pageIcon',
          label: '页面图标',
          type: 'input'
        }
      ]
    }
  }
}

export default pages
